import { JobFromAPI } from '../types';
import { transformJob } from './api-transforms';
import apiRequest from './apiRequest';

type JobPostPayload = {
  existingAnimationNumber: number;
  existingJobID: string;
  existingTrimStartFrame?: number;
  existingTrimEndFrame?: number;
  favoriteNewJob: boolean;
  hideFromHistory: boolean;
  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postJobFromExistingJob(props: JobPostPayload) {
  const response = await apiRequest<JobFromAPI>(
    'mogen-orchestration',
    '/jobs/fromExistingJob',
    {
      method: 'POST',
      body: JSON.stringify(props),
    },
  );

  return {
    data: transformJob(response.data),
    error: response.error,
  };
}
